import { Controller } from "@hotwired/stimulus"

const STRENGTH_LEVELS = [
  { score: 1, label: "Weak",        color: "bg-red-500" },
  { score: 2, label: "Fair",        color: "bg-orange-500" },
  { score: 3, label: "Good",        color: "bg-yellow-500" },
  { score: 4, label: "Strong",      color: "bg-emerald-500" },
  { score: 5, label: "Very Strong", color: "bg-emerald-600" },
]

export default class extends Controller {
  static targets = [
    "form", "success",
    "password", "confirm",
    "strengthMeter", "bar", "strengthLabel",
    "matchIcon", "checkIcon", "crossIcon", "mismatchMsg",
    "submitBtn"
  ]

  checkStrength() {
    const pw = this.passwordTarget.value
    if (!pw) {
      this.strengthMeterTarget.classList.add("hidden")
      return
    }

    this.strengthMeterTarget.classList.remove("hidden")
    const score = this.#score(pw)
    const level = STRENGTH_LEVELS[score - 1]

    this.barTargets.forEach((bar, i) => {
      bar.className = `h-1.5 flex-1 rounded-full transition-colors ${
        i < score ? level.color : "bg-slate-200"
      }`
    })
    this.strengthLabelTarget.textContent = level.label

    this.#updateSubmitState()
  }

  checkMatch() {
    const pw  = this.passwordTarget.value
    const cfm = this.confirmTarget.value
    if (!cfm) {
      this.matchIconTarget.classList.add("hidden")
      this.mismatchMsgTarget.classList.add("hidden")
      return
    }

    this.matchIconTarget.classList.remove("hidden")
    const match = pw === cfm
    this.checkIconTarget.classList.toggle("hidden", !match)
    this.crossIconTarget.classList.toggle("hidden", match)
    this.mismatchMsgTarget.classList.toggle("hidden", match)

    this.#updateSubmitState()
  }

  submit(event) {
    event.preventDefault()
    if (this.passwordTarget.value !== this.confirmTarget.value) return

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Updating..."

    setTimeout(() => {
      this.formTarget.classList.add("hidden")
      this.successTarget.classList.remove("hidden")
    }, 800)
  }

  #score(pw) {
    let s = 0
    if (pw.length >= 8)  s++
    if (pw.length >= 12) s++
    if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++
    if (/\d/.test(pw))   s++
    if (/[^a-zA-Z0-9]/.test(pw)) s++
    return Math.max(1, Math.min(5, s))
  }

  #updateSubmitState() {
    const pw  = this.passwordTarget.value
    const cfm = this.confirmTarget.value
    this.submitBtnTarget.disabled = !(pw && cfm && pw === cfm)
  }
}
